import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.sass']
})
export class LoadingComponent {
  /**
   * Tamanho do loading spinner
   * - 'xs': 16px (para uso inline em botões pequenos)
   * - 'sm': 20px (para uso inline em botões)
   * - 'md': 32px (para cards e seções)
   * - 'lg': 48px (para áreas maiores)
   * - 'xl': 64px (para tela cheia)
   * - 'full': 144px (tamanho original, tela cheia com overlay)
   */
  @Input() size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'full' = 'full';

  /**
   * Se true, mostra o loading centralizado com posição absoluta (para overlay)
   * Se false, mostra inline
   */
  @Input() overlay = true;

  /**
   * Texto opcional para mostrar abaixo do spinner
   */
  @Input() text?: string;

  get sizeClass(): string {
    const sizes = {
      'xs': 'w-4 h-4',
      'sm': 'w-5 h-5',
      'md': 'w-8 h-8',
      'lg': 'w-12 h-12',
      'xl': 'w-16 h-16',
      'full': 'w-36 h-36'
    };
    return sizes[this.size];
  }
}
